/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './Performance.scss';
import { Spinner } from '@trp-beacon-ui-kit/react-communication';

import { array, bool } from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import DisclosureModal from 'components/shared/Disclosure/DisclosureModal';
import Content, { contentConverter } from 'services/Content';
import {
  getCommentary,
  getConsolidatedPerformance,
  getProductPerformance,
  getAggregatedProductPerformance
} from 'services/Rest';

import PerformanceCharts from './Chart/PerformanceCharts';
import PerformanceWarningMessage from './PerformanceWarningMessage';
import { RATE_OF_RETURN_TYPE } from 'services/Commentary';
import { isRetirementAdvisoryServiceClient } from 'state/customer/CustomerSelectors';
import { getAccountsForRateOfReturn } from 'state/performance/RateOfReturnFilterSelectors';
import {
  hasLoadedRateOfReturn,
  shouldUseAggregatedPerformance
} from 'state/performance/PerformancePageSelectors';

const Performance = ({
  accounts,
  isRasClient,
  isLoaded,
  shouldUseAggregatedPerformance
}) => {
  useEffect(() => {
    getCommentary(RATE_OF_RETURN_TYPE);
  }, []);

  useEffect(() => {
    if (shouldUseAggregatedPerformance) {
      getAggregatedProductPerformance(accounts);
    }

    getProductPerformance(accounts);
    getConsolidatedPerformance(accounts);
  }, [accounts, shouldUseAggregatedPerformance]);

  return (
    <div className="performance-summary module module-container">
      <div className="left pure-u-3-4 pure-u-sm-1">
        {isLoaded ? <PerformanceCharts /> : <Spinner />}
      </div>
      <div className="pure-u-1-4 pure-u-sm-1 commentary-sidebar sidebar">
        <div className="disclosure">
          <div
            dangerouslySetInnerHTML={{
              __html: contentConverter.makeHtml(
                Content.performanceObservationsDisclosure
              )
            }}
          />
          {isRasClient && (
            <div
              dangerouslySetInnerHTML={{
                __html: contentConverter.makeHtml(
                  Content.performanceObservationsDisclosureForRasClient
                )
              }}
            />
          )}
          <DisclosureModal
            className="performance"
            content={Content.prrPerformanceDisclosure}
            iconAfter
          />
        </div>
      </div>
      <PerformanceWarningMessage />
    </div>
  );
};

Performance.propTypes = {
  accounts: array,
  isRasClient: bool,
  isRequesting: bool,
  shouldUseAggregatedPerformance: bool
};

const mapStateToProps = (state) => {
  return {
    accounts: getAccountsForRateOfReturn(state),
    isRasClient: isRetirementAdvisoryServiceClient(state),
    isLoaded: hasLoadedRateOfReturn(state),
    shouldUseAggregatedPerformance: shouldUseAggregatedPerformance(state)
  };
};

export default connect(mapStateToProps)(Performance);
